/*=========================================================================================
  File Name: moduleEcommerceMutations.js
  Description: Ecommerce Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  TOGGLE_ITEM_IN_WISH_LIST (state, item) {
    const index = state.wishList.findIndex(i => i.objectID === item.objectID)
    if (index < 0) {
      state.wishList.push(item)
    } else {
      state.wishList.splice(index, 1)
    }
  },
  REMOVE_ITEM_FROM_CART (state, item) {
    const index = state.cartItems.findIndex(i => i.objectID === item.objectID)
    if (index > -1) { state.cartItems.splice(index, 1) }
  },
  ADD_ITEM_IN_CART (state, item) {
    state.cartItems.push(Object.assign({}, item))
  },
  UPDATE_ITEM_QUANTITY (state, payload) {
    state.cartItems[payload.index].quantity = payload.quantity
  },
  UPDATE_VIEW_TYPE (state, payload) {
    state.cItemView = payload
  },
  setClient (state, client) {
    state.clientState = client
  },
  setProducts (state, products) {
    state.productState = products
  },
  setCantPage (state, cant) {
    state.total_pages = cant
  },
  UPDATE_RUCCED (state, payload) {
    state.ruccedState = payload
  },
  UPDATE_CODEMP (state, payload) {
    state.codempState = payload
  },
  UPDATE_PARAMS (state, payload) {
    state.paramState = payload
  },
  UPDATE_LISPRE (state, payload) {
    state.lispreState = payload
  },
  UPDATE_DESART (state, payload) {
    state.desartState = payload
  },
  UPDATE_DESCLI (state, payload) {
    state.descliState = payload
  },
  UPDATE_ORDERS (state, payload) {
    state.orderState = payload
  },
  UPDATE_subTotalState (state, payload) {
    state.subTotalState = payload
  },
  UPDATE_descuentoState (state, payload) {
    state.descuentoState = payload
  },
  UPDATE_totalNetoState (state, payload) {
    state.totalNetoState = payload
  },
  UPDATE_grabaIvaState (state, payload) {
    state.grabaIvaState = payload
  },
  UPDATE_noGrabaIvaState (state, payload) {
    state.noGrabaIvaState = payload
  },
  UPDATE_ivaState (state, payload) {
    state.ivaState = payload
  },
  UPDATE_totalState (state, payload) {
    state.totalState = payload
  },
  UPDATE_pedidoState (state, payload) {
    state.pedidoState = payload
  },
  UPDATE_historialPedidos (state, payload) {
    state.historialPedidos = payload
  },
  UPDATE_pedidoSeleccionado (state, payload) {
    state.pedidoSeleccionado = payload
  },
  UPDATE_empresas (state, payload) {
    state.empresas = payload
  },
  UPDATE_paramsCompany (state, payload) {
    state.paramsCompany = payload
  },
  UPDATE_clases (state, payload) {
    state.claseState = payload
  },
  UPDATE_zonas (state, payload) {
    state.zonaState = payload
  },
  UPDATE_cuentasCobrarState (state, payload) {
    state.cuentasCobrarState = payload
  },
  UPDATE_itemsPageState (state, payload){
    state.itemsPageState = payload
  }
}

